export default "__VITE_ASSET__b2844acb__"